/**
 * Utility to get the current user ID from various sources
 */

export function getCurrentUserId(): number | null {
  // Try to get from auth context state (if available via global)
  if (typeof window !== 'undefined' && (window as any).__currentUser) {
    return (window as any).__currentUser.id;
  }
  
  // Try to get from localStorage auth data (legacy)
  const authString = localStorage.getItem('auth');
  if (authString) {
    try {
      const auth = JSON.parse(authString);
      if (auth.user?.id) {
        return auth.user.id;
      }
    } catch (e) {
      console.error('Failed to parse auth data:', e);
    }
  }
  
  // Try to decode from JWT token (most reliable)
  const token = localStorage.getItem('access_token');
  if (token) {
    try {
      // JWT tokens have three parts separated by dots
      const parts = token.split('.');
      if (parts.length === 3) {
        // Decode the payload (second part)
        const payload = JSON.parse(atob(parts[1]));
        if (payload.sub) {
          // The 'sub' field typically contains the user ID
          return parseInt(payload.sub, 10);
        }
      }
    } catch (e) {
      console.error('Failed to decode JWT token:', e);
    }
  }
  
  return null;
}

// Store user in global for quick access (updated by AuthContext)
export function setGlobalUser(user: any) {
  if (typeof window !== 'undefined') {
    (window as any).__currentUser = user;
  }
}
